import React from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';
import { shipmentItemInventoryStatus } from '../../../../fulfillment-plan/sections/shipment-items/helpers/get-item-inventory-status';
import messages from '../../messages';
import { ItemStockComponent } from './item-stock-component';

const ItemStockColumnId = 'itemStock';

const itemStockDataBuilder = (inventoryStockLevelsMap, isInventoryLoading, item) => {
  return {
    ...inventoryStockLevelsMap[item.fulfillmentPlanItemId],
    isLoading: isInventoryLoading,
  };
};

const ItemStockCell = ({ cell, row }) => {
  const { itemInventoryStatus, shouldShowInventoryInfoUiTreatments } = row?.original || {};
  const { stockLevels = [], isLoading } = cell.value;

  return (
    <ItemStockComponent
      isLoading={isLoading}
      itemInventoryStatus={itemInventoryStatus}
      shouldShowInventoryInfoUiTreatments={shouldShowInventoryInfoUiTreatments}
      stockLevels={stockLevels}
    />
  );
};

ItemStockCell.propTypes = {
  cell: PropTypes.shape({
    value: PropTypes.shape({
      isLoading: PropTypes.bool,
      isUntracked: PropTypes.bool,
      stockLevels: PropTypes.array,
    }),
  }).isRequired,
  row: PropTypes.shape({
    original: PropTypes.shape({
      itemInventoryStatus: PropTypes.oneOf(Object.values(shipmentItemInventoryStatus)).isRequired,
    }),
  }).isRequired,
};

const createItemStockColumnDefinition = createColumnDefinitionBuilder({
  Header: <FormattedMessage {...messages.itemStock} />,
  accessor: ItemStockColumnId,
  Cell: ItemStockCell,
  width: 1,
});

export { ItemStockColumnId, itemStockDataBuilder, createItemStockColumnDefinition };
